import _ from 'lodash'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const compareArray = (a, b) => {
  if (a?.length === b?.length) {
    for (let i = 0; i < a?.length; i += 1) {
      if (!_.isEqual(a[i], b[i])) {
        return false
      }
    }
  } else {
    return false
  }
  return true
}

export const UI_TO_BACKEND_STATUS = {
  Compliant: 'none',
  'On hold': 'onhold',
  'Must complete drug screen': 'drugscreenrequired',
  'Must complete in-person visit': 'inpersonvisitrequired',
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function transformUIToBackendStatus(uiStatus) {
  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
  return UI_TO_BACKEND_STATUS[uiStatus] || 'none'
}

export const BACKEND_TO_UI_STATUS = {
  none: 'Compliant',
  onhold: 'On hold',
  drugscreenrequired: 'Must complete drug screen',
  inpersonvisitrequired: 'Must complete in-person visit',
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function transformBackendToUIStatus(backendStatus) {
  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
  return BACKEND_TO_UI_STATUS[backendStatus] || 'Compliant'
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function transformStatus(status) {
  if (Object.prototype.hasOwnProperty.call(BACKEND_TO_UI_STATUS, status)) {
    // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
    return BACKEND_TO_UI_STATUS[status]
  }

  const allUIValues = Object.values(BACKEND_TO_UI_STATUS)
  if (allUIValues.includes(status)) {
    return status
  }

  return 'Compliant'
}
